import { render } from "./AutenticacaoLayout.vue?vue&type=template&id=7a62b38e&ts=true"
import script from "./AutenticacaoLayout.vue?vue&type=script&lang=ts"
export * from "./AutenticacaoLayout.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\UniParking\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__